<script setup>
  import SearchPeopleNewComponent from "@/Components/Person/SearchPeopleNewComponent.vue";
  import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="Permissions.checkPermissions(['users.search'])">
        <SearchPeopleNewComponent/>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>